import React from "react";
import { t } from "ttag";

import { IReview } from "../../../models/reviews";

interface IProps {
    review: IReview;
}

export const ReviewSource = (props: IProps): React.JSX.Element => {
    return (
        <div>
            <div className="customer-review__source-title">
                <strong>{t`Source:`}</strong>
            </div>
            {props.review.source_name}
        </div>
    );
};
